// backendStatus — tiny observable for app-wide backend availability.
// The global fetch wrapper (main.jsx) flips this when /api calls return a 5xx
// gateway error (or fail outright) mid-deploy; BackendDownOverlay subscribes and
// shows the branded loader until a call succeeds again. Kept outside React so
// the non-React fetch wrapper can drive it.
let down = false;
const listeners = new Set();

export function getBackendDown() {
  return down;
}

export function setBackendDown(next) {
  if (down === next) return;
  down = next;
  listeners.forEach((listener) => listener(down));
}

export function subscribeBackendStatus(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
